import { render } from "./HorizontalPaging.vue?vue&type=template&id=58d57a1a&ts=true"
import script from "./HorizontalPaging.vue?vue&type=script&lang=ts"
export * from "./HorizontalPaging.vue?vue&type=script&lang=ts"

import "./HorizontalPaging.vue?vue&type=style&index=0&id=58d57a1a&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__